import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    usuario: null,
    tickets_filter: null,
    cashflow_filter: null
  },
  mutations: {
    LOGIN_SUCCESS(state, response) {
      state.usuario = response.usuario
      state.usuario.token = response.token
    },
    LOGOUT(state) {
      state.usuario = null
    },
    TICKETS_FILTER(state, filter) {
      state.tickets_filter = filter
    },
    CASHFLOW_FILTER(state, filter) {
      state.cashflow_filter = filter
    }
  }
})
